/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { memo, useEffect, useRef, useState } from "react";

const confirmImage = memo((props) => {
  // 状態定義
  const [url, setUrl] = useState();
  const [isPortrait, setIsPortrait] = useState(false);

  // 要素参照定義
  const imageRef = useRef(null);
  const wrapperRef = useRef(null);

  // ウインドウサイズ変更時に画像のサイズ調整を行う
  const resizeObserver = new ResizeObserver(() => {
    resize();
  });

  useEffect(() => {
    setUrl(props.src);
    // 画像登録時にリサイズ検知機能を有効化する
    if (props.src) {
      resizeObserver.observe(document.body);
    } else {
      resizeObserver.disconnect();
    }
  }, [props.src]);

  // 幅ベース、高さベースのどちらでサイズ指定を行うかを画像の縦横比により決定
  const resize = () => {
    if (imageRef.current && wrapperRef.current) {
      const imageH = Number(imageRef.current.height);
      const imageW = Number(imageRef.current.width);
      const wrapperW = Number(wrapperRef.current.getBoundingClientRect().width);
      setIsPortrait((imageH / imageW) * wrapperW > 90);
    }
  };
  return (
    <div css={imgLayout} ref={wrapperRef}>
      <img
        ref={imageRef}
        css={[imgPosition, isPortrait ? h100p : w100p]}
        src={url}
        alt={url}
        onLoad={() => resize()}
      />
    </div>
  );
});

const imgLayout = css`
  width: 100%;
  height: 90px;
  background-color: var(--mtg-grey-3);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const imgPosition = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const h100p = css`
  height: 100%;
`;

const w100p = css`
  width: 100%;
`;

export default confirmImage;
